import { useCallback, useEffect, useState } from "react";
import TextInput from "../../../../../../UI/TextInput";
import UUIDInput from "../../../../../../UI/UUIDInput";

interface ImageModalInputProps {
  value?: PartialImageModal;
  onChange?: (content: PartialImageModal) => void;
}

const DEFAULT_VALUE: PartialImageModal = {
  type: "image",
  title: "",
  src: "",
  text: "",
};

const ImageModalInput = ({ value, onChange }: ImageModalInputProps) => {
  const [content, setContent] = useState<PartialImageModal>();
  useEffect(() => {
    setContent(value || DEFAULT_VALUE);
  }, [value]);

  const handleChange = useCallback(
    (update: PartialImageModal) => {
      const updated: PartialImageModal = { ...content, ...update };
      setContent(updated);
      onChange?.(updated);
    },
    [onChange, content],
  );

  return (
    <>
      <TextInput
        label="Title"
        value={content?.title}
        onChange={(title) => handleChange({ title })}
      />
      <UUIDInput
        value={content?.src}
        onChange={(src) => handleChange({ src })}
        required
      />
      <TextInput
        label="Text"
        value={content?.text}
        onChange={(text) => handleChange({ text })}
        textarea
      />
    </>
  );
};

export default ImageModalInput;
